<db-dialog-wrapper [dialog]="this" [canClose]="!loading" [hasCloseButton]="!loading" [canCloseByBackdrop]="!loading" [width]="'500px'" [height]="'238px'">
  <div class="db-remove-payment-method">
    <div class="db-remove-payment-method__update">
      <h3>{{'text_removePaymentMethodTitle' | dbText}}</h3>
      <p [innerHTML]="'text_removePaymentMethodDesc' | dbText"></p>
      <db-payment-method-item [withShadow]="true" [showDropdown]="false" [paymentMethod]="paymentMethod" [userSubscription]="userSubscription" [userPaymentMethod]="paymentMethod?.creditCard?.type"></db-payment-method-item>
      <div class="db-remove-payment-method-buttons mt15">
        <a class="ds-btn" (click)="close_window()"><span>{{'text_cancel' | dbText}}</span></a>
        <a class="ds-btn-red" [ngClass]="{'ds-btn-disabled': loading}"  (click)="deletePaymentMethod(paymentMethod.id)">
          <span *ngIf="!loading">{{'text_yesRemove' | dbText}}</span>
          <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </a>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
